module.exports = __webpack_public_path__ + "img/olympic.36e49a40.svg";